// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_WBD","badges":"styles_badges__1cdfx"};